import React from 'react';
import { useTranslation } from 'react-i18next';

import './SearchResults.css'
import Card from "../Card/Card";

const SearchHistory = ({clickEvent}) => {
    const {t} = useTranslation();

    const clearHistory = () => {
        localStorage.removeItem("CustomerSearchHistory");
    }

    const customerSearchHistory = localStorage.getItem("CustomerSearchHistory");

    const customers = customerSearchHistory ? JSON.parse(customerSearchHistory) : [];


    if (!customers || customers.length === 0)
        return null;

    return <Card>
        <Card.CHeader>
            <Card.Header.Title>{t('searchhistory.lastvisitedcustomer')}</Card.Header.Title>
        </Card.CHeader>
        <Card.Content>
            <table className="table table-stripe table-hover">
                <thead>
                <tr>
                    <th width="200" className="text-right">{t('searchhistory.organizationnumber')} </th>
                    <th width="200" className="text-right">{t('searchhistory.customernumber')} </th>
                    <th>{t('searchhistory.name')} </th>
                </tr>
                </thead>
                <tbody>
                {
                    customers.reverse().map(customer =>
                        <tr key={customer.customerNumber ?? customer.pathId} onClick={() => clickEvent(customer.customerNumber ?? customer.pathId)}
                            className="cursorpointer">
                            <td className="text-right">{customer.organizationNumber ?? "N/A"}</td>
                            <td className="text-right">{customer.customerNumber ?? "N/A"}</td>
                            <td className="text-left">{customer.name}</td>
                        </tr>
                    )
                }
                </tbody>
            </table>
        </Card.Content>
    </Card>
}

export default SearchHistory;